<template>
  <TMainForm :script-id="scriptId" :interception="interception" :default-design="defaultDesign"
    :default-change-script="defaultChangeScript" :default-proccess-script="defaultProccessScript" :buttons="buttons" />
</template>

<script setup>
/**
 * TTMBlockForm
 */
import TMainForm from './TMainForm.vue';
import { FORM_DESIGNS, FORM_CHANGE_SCRIPTS, FORM_PROCESS_SCRIPTS } from './constants';

const props = defineProps({
  scriptId: { type: Number, default: null },
  interception: { type: [String, Object, Boolean], default: null },
});

const buttons = [];
const defaultDesign = FORM_DESIGNS.TTMBlockForm;
const defaultChangeScript = FORM_CHANGE_SCRIPTS.TTMBlockForm;
const defaultProccessScript = FORM_PROCESS_SCRIPTS.TTMBlockForm;
</script>
